(function () {
  'use strict';

  /* @ngdoc object
   * @name layoverSummaryReport
   * @description
   *
   */
  angular
    .module('layoverSummaryReport', [
      'ui.router'
    ]);
}());
